<div>
  <div class="flex flex-col justify-center items-center content-center" fxFlexFill>
    <img src="../../assets/images/beefund-banner.png" />
    <h1>Oeps... Er is iets fout gegaan.</h1>
    <p>Probeer het <a (click)="backClick()">opnieuw</a> of ga naar de <a routerLink="">homepagina</a>.</p>
    <p>Of stuur een e-mail naar <a href="mailto:info@beefund.app">info&#64;beefund.app</a></p>
  </div>
</div>
